<div
  class="desktop-list-item"
  tappable
  (click)="clicked.emit()"
  [ngClass]="{
    bold: selected,
  }"
>
  <div class="desktop-list-item__icon"><ng-content select="itl-desktop-list-item-icon"></ng-content></div>
  <div class="desktop-list-item__content">
    <div class="content">
      <div class="header"><ng-content></ng-content></div>
      <div class="additionalInfo"><ng-content select="itl-desktop-list-item-additional-info"></ng-content></div>
    </div>
    <div class="status">
      <ng-content select="itl-desktop-list-item-status"></ng-content>
    </div>
  </div>
</div>
